<template>
  <div class="orders-container">
    <!-- Search and Action Section -->
    <div style="display: flex">
      <div>
        <el-input
            v-model="searchForm.userId"
            clearable
            size="small"
            placeholder="请输入用户ID"
            @clear="handleClear('userId')"
            @input="handleSearch">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="fetchOrders">查询</el-button>
      </div>
      <div>
        <el-input
            v-model="searchForm.money"
            clearable
            size="small"
            placeholder="请输入金额"
            @clear="handleClear('money')"
            @input="handleSearch">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="fetchOrders">按金额查询</el-button>
      </div>
      <!-- 新增卡密查询账号功能 -->
      <div style="padding-left: 10px;">
        <el-input
            v-model="searchForm.kami"
            clearable
            size="small"
            placeholder="请输入卡密"
            @clear="handleClear('kami')">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="getAccountByKami">查询账号</el-button>
      </div>
    </div>

    <!-- Table Section -->
    <el-table
        :data="orders"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          type="index"
          label="序号"
          width="60">
      </el-table-column>
      <el-table-column
          prop="id"
          label="订单ID"
          width="120">
      </el-table-column>
      <el-table-column
          prop="userId"
          label="用户ID"
          width="120">
      </el-table-column>
      <el-table-column
          prop="kamilId"
          label="卡密ID"
          width="120">
      </el-table-column>
      <el-table-column
          prop="money"
          label="金额"
          width="100">
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.updateTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination Section -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalOrders">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';
import { Message } from 'element-ui';

export default {
  data() {
    return {
      searchForm: {
        userId: '',
        money: '',
        kami: '' // 新增卡密字段
      },
      orders: [],
      totalOrders: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  methods: {
    handleSelectionChange() {
      // 处理选择变化的逻辑
    },
    async fetchOrders() {
      try {
        const response = await axios.post(`/api/admin/orders/page`, {
          userId: this.searchForm.userId ? Number(this.searchForm.userId) : null,
          current: this.currentPage,
          size: this.pageSize,
          money: this.searchForm.money ? Number(this.searchForm.money) : null,
        },{
          headers: {
            'token': this.$cookies.get('token')
          }
        });
        this.orders = response.data.data;
        this.totalOrders = response.data.total;
      } catch (error) {
        Message.error('Error fetching orders: ' + error.message);
      }
    },
    handleSearch() {
      this.currentPage = 1; // 重置到第一页
      this.fetchOrders();
    },
    handleClear(attribute) {
      this.searchForm[attribute] = '';
      if (attribute !== 'kami') {
        this.handleSearch();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchOrders();
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : '';
    },
    // 新增通过卡密查询账号的方法
    async getAccountByKami() {
      if (!this.searchForm.kami) {
        Message.warning('请输入卡密');
        return;
      }
      try {
        const response = await axios.get('/api/admin/orders/getAccount', {
          params: { kami: this.searchForm.kami },
          headers: { 'token': this.$cookies.get('token') }
        });
        if (response.data.code === 200) {
          Message.success('查询成功');
          // 这里可以根据实际需求处理返回的账号信息
          console.log(response.data.data);
          // 例如，可以打开一个对话框显示账号信息
          this.$alert(JSON.stringify(response.data.data), '账号信息', {
            confirmButtonText: '确定'
          });
        } else {
          Message.error(response.data.msg || '查询失败');
        }
      } catch (error) {
        Message.error('查询账号时出错: ' + error.message);
      }
    }
  },
  mounted() {
    this.fetchOrders(); // 在组件挂载时获取订单数据
  }
}
</script>

<style scoped>
.orders-container .el-table th {
  background-color: #f5f7fa;
}
.orders-container /deep/ .el-table td, .orders-container /deep/ .el-table th {
  padding: 8px 0;
}
.orders-container /deep/ .el-table .cell {
  line-height: 30px;
}
</style>
